// Search Box
(() => {
    const trigger = document.querySelector('.search-box__trigger');
    const form = document.querySelector('.search-box__form');
    const input = document.getElementById('searchTerm');
    const focusDelay = 100;

    if (!trigger || !form) return;

    const close = () => {
        form.classList.remove('search-box__form--active');
        document.querySelector('.header').classList.remove('search-box--open');
        trigger.setAttribute('aria-expanded', 'false');
        form.querySelectorAll('input, button').forEach((el) => (el.tabIndex = -1));
    };

    const toggle = () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // Close other nav elements when opening
        if (!isOpen && window.nav) {
            document.querySelectorAll('.nav__chevron').forEach(window.nav.closeDropdown);
            window.nav.closeMobile();
        }

        form.classList.toggle('search-box__form--active');
        document.querySelector('.header').classList.toggle('search-box--open');
        trigger.setAttribute('aria-expanded', !isOpen);

        form.querySelectorAll('input, button').forEach((el) => (el.tabIndex = isOpen ? -1 : 0));
        if (!isOpen) setTimeout(() => input.focus(), focusDelay);
    };

    // Events
    trigger.addEventListener('click', toggle);
    trigger.addEventListener(
        'keydown',
        (e) => (e.key === 'Enter' || e.key === ' ') && (e.preventDefault(), toggle())
    );

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
            close();
            trigger.focus();
        }
    });

    document.addEventListener('click', (e) => {
        if (trigger.getAttribute('aria-expanded') === 'true' && !e.target.closest('.search-box'))
            close();
    });

    // Global access
    window.search = { close };
})();
